const classes = {
    plantInfoWrapper: (theme) => ({
        position: 'relative',
        paddingTop: theme.spacing(2.5),
        paddingBottom: theme.spacing(2.5),
    }),
    plantInfoWrapperItems: (theme) => ({
        paddingBottom: theme.spacing(9),
    }),
    plantImage: {
        backgroundColor: 'transparent',
        width: 83,
        height: 100,
    },
    plantInfo: (theme) => ({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingLeft: theme.spacing(1.75),
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingLeft: theme.spacing(1.75),
        },
    }),
    plantInfoCart: (theme) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingLeft: theme.spacing(1.75),
    }),
    plantName: (theme) => ({
        color: theme.palette.primary.dark,
        padding: 0,
        fontSize: theme.spacing(2.25),
        fontWeight: 'bold',
        textTransform: 'none',
        textAlign: 'left',
        lineHeight: '23px',
        letterSpacing: '0.06em',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),
    plantSize: (theme) => ({
        color: theme.palette.blueColors.main,
        paddingTop: theme.spacing(0.75),
        fontSize: theme.spacing(1.75),
        fontWeight: 400,
        lineHeight: '18px',
        letterSpacing: '0.06em',
    }),
    removeButton: (theme) => ({
        padding: 0,
        marginTop: theme.spacing(1.5),
        textTransform: 'none',
        color: theme.palette.blueColors.main,
        fontWeight: 400,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),
    quantityPrice: (theme) => ({
        flexDirection: 'row',
        justifyContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
            paddingTop: theme.spacing(2.5),
        },
    }),
    quantityPriceCart: (theme) => ({
        justifyContent: 'flex-start',
        paddingTop: theme.spacing(2.5),
    }),
    plantPrice: (theme) => ({
        color: theme.palette.primary.dark,
        fontSize: theme.spacing(1.75),
        fontWeight: 400,
        lineHeight: '30px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(5),
            color: theme.palette.primary.dark,
            fontSize: theme.spacing(1.75),
            fontWeight: 400,
            lineHeight: '30px',
        },
    }),
    plantPriceCart: (theme) => ({
        paddingLeft: theme.spacing(5),
        color: theme.palette.primary.dark,
        fontSize: theme.spacing(1.75),
        fontWeight: 400,
        lineHeight: '30px',
    }),
};
export default classes;
